import { t, type TranslationKey } from '../i18n';
import { $, h, link, pad, svg } from '../ui/dom';
import { icons, SOCIALS } from '../ui/icons';

export function mountContacts(): void {
  const grid = $('contacts-grid');
  if (!grid) return;
  grid.replaceChildren(
    ...SOCIALS.map((s, i) =>
      link(
        s.url,
        `contact-card contact-${s.key}`,
        h('span', 'contact-index mono', pad(i + 1)),
        svg(icons[s.key], 'icon contact-icon'),
        h('h3', { text: s.label }),
        h('p', { text: t(`contacts.${s.key}` as TranslationKey) }),
        h('span', 'contact-handle mono', s.handle, svg(icons.external)),
      ),
    ),
  );
}
